import React from 'react';
import { ExternalLink } from 'lucide-react';

const GmbBadge = ({ variant = 'dark', className = '' }) => {
  const isLight = variant === 'light';

  return (
    <a
      href="https://share.google/1AdkdTRRxYH3lkWHY"
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full transition-all duration-300 shadow-md hover:shadow-lg hover:scale-[1.02] group ${
        isLight
          ? 'bg-slate-900/5 hover:bg-slate-900/10 border border-slate-900/15 text-slate-800'
          : 'bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 text-white'
      } ${className}`}
      title="View XD Media on Google Business Profile"
    >
      <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
      </svg>
      <div className="flex items-center gap-1.5 text-xs sm:text-sm font-medium">
        <span className="font-semibold">XD Media</span>
        <span className="text-amber-400 font-bold flex items-center gap-0.5">
          5.0 <span className="tracking-tighter text-amber-400">★★★★★</span>
        </span>
        <span className={`${isLight ? 'text-slate-500' : 'text-slate-300'} text-xs hidden sm:inline`}>on Google</span>
      </div>
      <ExternalLink className={`w-3 h-3 ${isLight ? 'text-slate-400 group-hover:text-slate-700' : 'text-white/70 group-hover:text-white'} transition-colors ml-0.5`} />
    </a>
  );
};

export default GmbBadge;
